import Context from './Context.js';
import TrackingIpFilter from '../storage/TrackingIpFilter.js';

export default class Default extends Context {
  constructor(eventType, isFiltered) {
    super();
    this.data = {
      ev_ty: eventType,
      ev_if: isFiltered === undefined ? TrackingIpFilter.get() : isFiltered
    };
  }

  static get key() {
    return 'default_event_context'
  }

  static get TYPE_INTERACTION() {
    return 'interaction';
  }

  static get TYPE_SUBSCRIPTION() {
    return 'subscription';
  }

  static get TYPE_ENQUIRY() {
    return 'enquiry';
  }

  static get TYPE_BOOKING() {
    return 'booking';
  }

  static get TYPE_TRANSACTION() {
    return 'transaction';
  }
}
